import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import ReactTooltip from 'react-tooltip';
import { doesClientHaveActiveChurnThreat } from 'modules/functions';

const ClientStatusLegend = ({ client }) => {
  const {
    isDisengaged,
    isTransfer,

    isNew,
    vacationUntil,
    highPriority,
  } = client;

  const isChurnThreat = doesClientHaveActiveChurnThreat(client.churnThreats);

  const isOnVacation =
    moment(vacationUntil).isValid &&
    moment(vacationUntil).isAfter(moment(), 'day');
  const legendKeys = [];
  if (isNew) {
    legendKeys.push({ initial: 'N', full: 'New' });
  }
  if (isDisengaged) {
    legendKeys.push({
      initial: 'D',
      full: 'Disengaged',
    });
  }
  if (isTransfer) {
    legendKeys.push({
      initial: 'T',
      full: 'Transfer',
    });
  }
  if (isChurnThreat) {
    legendKeys.push({
      initial: 'C',
      full: 'Churn Threat',
    });
  }
  if (highPriority) {
    legendKeys.push({
      initial: 'H',
      full: 'High Priority',
    });
  }
  if (isOnVacation) {
    legendKeys.push({
      initial: 'V',
      full: 'Vacation Mode',
    });
  }

  return (
    <div className="d-flex flex-column align-items-center user-legend">
      <ReactTooltip />
      {legendKeys.map((key) => (
        <span
          data-tip={key.full}
          className="client-legend-item"
          key={key.initial}
        >
          {key.initial}
        </span>
      ))}
    </div>
  );
};

ClientStatusLegend.propTypes = {
  client: PropTypes.object.isRequired,
};

export default ClientStatusLegend;
